<template>
    <div style="background-color:#2E353E;width:100vw">
        <div class="box">
            <div class="box-title">
                <img src="../assets/bottom-logo.png" style="width: 62px;height: 62px;" alt="" srcset="">
                <div class="text">
                    <div>深圳市繁淼信息科技有限公司</div>
                    <div>Shenzhen Fanmiao Information Technology Co. LTD</div>
                </div>
            </div>
            <div class="context">
                <div class="context-message">
                    <div class="message-item">
                        <img src="../assets/bottom-phone.png" alt="" srcset="">
                        <div class="message-line"></div>
                        <div class="message-text">13076925919（陈生）</div>
                    </div>
                    <div style="margin-top: 22px;margin-bottom: 22px;" class="message-item">
                        <img src="../assets/bottom-location.png" alt="" srcset="">
                        <div class="message-line"></div>
                        <div class="message-text">广东省深圳市宝安区留仙二路南天辉创研大厦</div>
                    </div>
                    <!-- <div class="message-item"  @click="toUrlBtnB">
                        <img src="../assets/bottom-address.png" alt="" srcset="">
                        <div class="message-line"></div>
                        <div class="message-text brjAC">深圳市百仁吉科技有限公司</div>
                    </div> -->
                </div>
                <div class="context-code">
                    <div>
                        <img src="../assets/qrcode1.png" alt="">
                        <span>繁淼公众号</span>
                    </div>
                    <div>
                        <img src="../assets/qrcode2.png" alt="">
                        <span>嘉马小程序</span>
                    </div>
                </div>
                <div class="context-introduce">
                    <div class="introduce-title">
                        产品介绍
                    </div>
                    <div class="introduce-title-grid">
                        <div style="cursor: pointer;" v-for="(item,index) in list" @click="toEmunBtn(item)">
                            {{ item.name }}
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="common-width bottom">
                <div class="bottom-line"></div>
                <div style="display: flex;justify-content: center;">
                    <span class="text" @click="toUrlBtn">版权所有©2003-2024 深圳繁淼信息科技有限公司 粤ICP备2023085359号</span>
                    <!-- <span class="text" style="margin-left: 10px;">客服热线:18620373857</span>
                    <span class="text" style="margin-left: 10px;">运营主体:深圳繁淼科技有限公司</span>   -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
      name:'copyright',
      data(){
        return {
            list:[
                {name:'繁淼充电桩',url:'energy'},
                {name:'嘉马商城',url:'gaMall'},
                {name:'商家入驻',url:'merchant'},
                {name:'物联平台',url:'internet'},
                {name:'嘉马民宿',url:'homestay'},
            ]
        }
      },
      methods:{
          toEmunBtn(item){
            let list = this.$parent.$refs.navRef.getlistFun();
            let listItem = {};
            for(let i = 0; i < list.length; i++){
                
                if (list[i].url.includes(item.url)) { 
                    listItem = {list:list[i],index:i};
                    break;
                }
            }

            this.$parent.$refs.navRef.setIndexFun(listItem.index);

            this.$router.push(item.url)

          },
          toUrlBtn(){
              window.open('http://beian.miit.gov.cn/')
          },
          toUrlBtnB(){
              window.open('https://www.brjkj.com/')
          }
      }
  }
</script>
<style lang="scss" scoped>
   .box{
      width:1200px;
      height: 462px;
      background: #2E353E;
      position: relative;
      box-sizing: border-box;
    //   padding-left: 360px;
    //   padding-right: 360px;
      margin: 0 auto;
      padding-top: 51px;
      .box-title{
        display: flex;
        margin-bottom: 82px;
        .text{
            box-sizing: border-box;
            padding-top: 9px;
            div:nth-child(1){
                font-size: 28px;
                font-family: Alibaba_Bold;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 24px;
                margin-bottom: 7px;
            }
            div:nth-child(2){
                font-size: 12px;
                font-family: Helvetica;
                color: #B5B8BD;
                line-height: 12px;
                opacity: .7;
            }
        }
      }
      .context{
        display: flex;
        justify-content: space-between;
        .context-message{
            .message-item{
                display: flex;
                align-items: center;
                img{
                    width: 22px;
                    height: 22px;
                }
                .message-line{
                    width: 1px;
                    height: 14px;
                    background: #FFFFFF;
                    opacity: 0.75;
                    margin-left: 15px;
                    margin-right: 15px;
                }
                .message-text{
                    font-size: 16px;
                    font-family: Alibaba_Regular;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 22px;
                }
            }

            .brjAC:hover{
                color:#367CFF; 
                cursor: pointer;
            }
        }
        .context-code{
            display: flex;
            div{
                display: flex;
                flex-direction: column;
                img{
                    margin-bottom:10px;
                }
                span{
                    text-align: center;
                    font-size: 14px;
                    font-family: Alibaba_Regular;
                    font-weight: 400;
                    color: #C2C5CA;
                    line-height: 20px;
                }
            }
            div:nth-child(2){
                margin-left: 30px;
            }
        }
        .context-introduce{
            .introduce-title{
                font-size: 16px;
                font-family: Alibaba_Bold;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 22px;
                margin-bottom: 20px;
            }
            .introduce-title-grid{
                display: grid;
                grid-template-columns:repeat(3,110px);
                grid-template-rows: 15px;
                grid-row-gap:14px;
                div{
                    font-size: 16px;
                    font-family: Alibaba_Regular;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 22px;
                    opacity: .7;
                }
            }
        }
      }
      .bottom{
        margin-top: 60px;
        font-size: 14px;
        font-family: Alibaba_Regular;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        .bottom-line{
            width: 100%;
            height: 1px;
            background: #FFFFFF;
            opacity: 0.6;
            margin-bottom: 24px;
        }
      }
   }
</style>